// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "c302224e020a8115","396": "30d4b96bb55beba7","460": "f503bd078d56b807","917": "9d0907990327e25d","985": "463967f8d1858481",}[chunkId] + ".chunk.js"
}